<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <VLayout row>
    <VFlex sm4 class="hidden-xs-only">
      <VSubheader class="align-end">
        {{ label }}
      </VSubheader>
    </VFlex>

    <VFlex sm8>
      <slot />
    </VFlex>
  </VLayout>
</template>
